import React from "react";

const List = ({ activeImg, onHoverHandler }) => {
  return (
    <>
      <div
        data-v-727718ae=""
        data-v-08671491=""
        className="grid grid-rows-3 text-xl xl:text-3xl transform transition-all duration-300 ease-in-out"
      >
        <div
          className="w-full flex flex-col items-start justify-start group cursor-pointer"
          onMouseEnter={() => onHoverHandler(1)}
        >
          <div
            data-v-08671491=""
            className={`w-full flex items-center justify-between group py-8 border-b-4 border-primary-light hover:border-green-700 transform transition-all duration-500 animate-slideInRight`}
          >
            <a
              href="https://maps.app.goo.gl/Q3G76FbHeKJMNnN48"
              target="_blank"
              className="group-hover:text-primary-orange transform duration-300 ease-in-out tracking-widest"
              rel="noreferrer"
            >
              საუკეთესო ლოკაცია
            </a>
          </div>
        </div>
        <div
          className="w-full flex flex-col items-start justify-start group "
          onMouseEnter={() => onHoverHandler(2)}
        >
          <div
            className={`w-full flex items-center justify-between group py-8 border-b-4 border-primary-light hover:border-green-700 transform duration-300 animate-slideInRight`}
          >
            <p
              className="group-hover:text-primary-orange transform duration-300 ease-in-out tracking-widest"
              rel="noreferrer"
            >
              დაცული გარემო
            </p>
          </div>
        </div>
        <div
          className="w-full flex flex-col items-start justify-start group "
          onMouseEnter={() => onHoverHandler(3)}
        >
          <div
            data-v-08671491=""
            className={`w-full flex items-center justify-between group py-8 border-b-4 border-primary-light hover:border-green-700 transform duration-300 animate-slideInRight`}
          >
            <p
              className="group-hover:text-primary-orange transform duration-300 ease-in-out tracking-widest"
              rel="noreferrer"
            >
              გამორჩეული არქიტექტურა
            </p>
          </div>
        </div>
        <div
          className="w-full flex flex-col items-start justify-start group "
          onMouseEnter={() => onHoverHandler(4)}
        >
          <div
            data-v-08671491=""
            className={`w-full flex items-center justify-between group py-8 border-b-4 border-primary-light hover:border-green-700 transform duration-300 animate-slideInRight`}
          >
            <p
              className="group-hover:text-primary-orange transform duration-300 ease-in-out tracking-widest"
              rel="noreferrer"
            >
              სიმყუდროვე
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default List;
